import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { trackPageView } from '../utils/usageTracker';
import { PaymentMethodsCard } from '../components/PaymentMethodsCard';
import useBillingAndPaymentsData from '../hooks/useBillingAndPaymentsData';
import { jsx as _jsx } from "react/jsx-runtime";
export function Payments() {
  const {
    data: {
      paymentMethods
    }
  } = useBillingAndPaymentsData();
  useEffect(() => {
    trackPageView('payments');
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PAYMENTS_LOAD",
    children: /*#__PURE__*/_jsx(PaymentMethodsCard, {
      paymentMethods: paymentMethods
    })
  });
}